export default __webpack_public_path__ + "static/media/KP.2a875417.svg";